import { createElement } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import { PrizeStatus } from '@/types/shared';
import CountDown from './CountDown';
import './index.scss';
import { formatTimestampToDate } from '@/utils/common';
export var TextType;
(function (TextType) {
    TextType["SMALL"] = "small";
    TextType["NORMAL"] = "normal";
})(TextType || (TextType = {}));
const textStyle = {
    [TextType.SMALL]: {
        fontSize: '20rpx'
    },
    [TextType.NORMAL]: {
        fontSize: '24rpx'
    }
};
const CountDownDescription = ({ prize, className = '', textType = TextType.NORMAL }) => {
    const { month, day } = formatTimestampToDate(prize.expireTime);
    // 获取显示内容
    const getExpireContent = () => {
        if (prize.prizeStatus === PrizeStatus.CAN_DRAW) {
            return <Text className="expire-text" style={textStyle[textType]}>
          专属福利快来拿
        </Text>;
        }
        if (prize.prizeStatus === PrizeStatus.DRAWN || prize.prizeStatus === PrizeStatus.NOT_USED) {
            // 已领取，倒计时大于1天，显示expireDesc
            if (prize.expireIsOverDay) {
                return <Text className="expire-text" style={textStyle[textType]}>
            {`${month}月${day}日到期` || '长期有效'}
          </Text>;
            }
            // 判断是否需要显示倒计时
            const showCountDown = !prize.expireIsOverDay && prize.expireTime;
            // 已领取，倒计时小于等于1天，显示倒计时
            if (showCountDown) {
                return <CountDown endTime={prize.expireTime} suffix="后到期" fontSize={textStyle[textType].fontSize}/>;
            }
            return <Text className="expire-text" style={textStyle[textType]}>专属福利</Text>;
        }
        return <Text className="expire-text" style={textStyle[textType]}>
        专属福利快来拿
      </Text>;
    };
    return <View className={`count-down-description-wrapper ${className}`}>{getExpireContent()}</View>;
};
export default CountDownDescription;
